module.exports = __webpack_public_path__ + "img/activation-type-archived.556719fd.svg";